import React from 'react';
import './ConnectionStatusOverlay.css';
import NoInternet from '../assets/images/no-internet.gif'

const ConnectionStatusOverlay = ({ isOffline }) => {
    if (!isOffline) return null;

    return (
        <div className="overlay">
           <div className="text-center">
            <div className='mb-3'>
                <img src={NoInternet} />
            </div>
            <div className="message">
                <h2>You've lost internet connection</h2>
                <p>Try again later.</p>
            </div>
           </div>
        </div>
    );
};

export default ConnectionStatusOverlay; 